/**
 * 直播间 API（118 方案 P4：观看端由 Java 老后端迁移到 ai_mall_py）。
 *
 * 变更说明：
 * - 原走 Global.BASE_URL(8090) + /api/live/default*，现走 aiApiUtil 通道
 *   （AI_BASE_URL 别名，见 api-util.js / public/js/global.js），路径不变
 * - py 响应为 GlxVo 信封，glxGet 统一解包取 data；data 内字段与 Java
 *   camelCase 逐字一致（{live, bgImgUrl} / {liveId, pauseSeconds, startTime}），
 *   消费方（useFetchDefaultLive / live.jsx / videoPanel）零改动
 */
import {glxGet} from './aiApiUtil';

export async function defaultLive() {
    return glxGet('/live/default')
}

export async function defaultLiveContext() {
    return glxGet('/live/default/context')
}
